import type { Task } from 'redux-saga';
import { all, cancel, fork, take } from 'redux-saga/effects';

import { authSessionEnd, authSessionStart } from '@/modules/auth/services/actions';

import loadSecrets from './loadSecrets';
import syncSecrets from './syncSecrets';
import timingSecretsSync from './timingSecretsSync';

function* loadAndSyncSecrets() {
    yield all([loadSecrets(), timingSecretsSync(), syncSecrets()]);
}

export default function* () {
    while (true) {
        yield take(authSessionStart);

        const task: Task = yield fork(loadAndSyncSecrets);

        yield take(authSessionEnd);

        yield cancel(task);
    }
}
